import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";

import { MyApp } from "./app.component";
import { HomePage } from "../pages/home/home";
import { ComponentsModule } from "../components/components.module";
import { HexonProvider } from "../providers/hexon/hexon";
import { CommonModule } from "@angular/common";
import { SettingsPage } from "../pages/settings/settings";
import { NewLinkPage } from "../pages/new-link/new-link";
import { CommentsPage } from "../pages/comments/comments";
import { BlockedVehiclesPage } from "../pages/blocked-vehicles/blocked-vehicles";
import { SiteSettingsPage } from "../pages/site-settings/site-settings";
import { RestHttpInterceptor } from "../providers/http-interceptor/http-interceptor";
import { SearchProvider } from "../providers/search/search";
import { SitesPage } from "../pages/sites/sites";
import { PipesModule } from "../pipes/pipes.module";
import { EscapeProvider } from "../providers/escape/escape";
import { LoginProvider } from "../providers/login/login";
import { RouterModule, Routes } from "@angular/router";
import { Rfc3339DateProvider } from "../providers/rfc3339date/rfc3339date";
import { RefreshProvider } from "../providers/refresh/refresh";
import { DomProvider } from "../providers/dom/dom";

const appRoutes: Routes = [
  { path: "oct", component: MyApp }, // Only for test environment
  { path: "**", component: MyApp },
];

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    SettingsPage,
    NewLinkPage,
    CommentsPage,
    BlockedVehiclesPage,
    SiteSettingsPage,
    SitesPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    CommonModule,
    ComponentsModule,
    HttpClientModule,
    PipesModule.forRoot(),
    RouterModule.forRoot(appRoutes),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    SettingsPage,
    NewLinkPage,
    CommentsPage,
    BlockedVehiclesPage,
    SiteSettingsPage,
    SitesPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    HexonProvider,
    RestHttpInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RestHttpInterceptor,
      multi: true,
    },
    SearchProvider,
    EscapeProvider,
    LoginProvider,
    Rfc3339DateProvider,
    RefreshProvider,
    DomProvider,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts